<template>
  <div>
    <Form
      :label-width="100"
      style="width: 100%"
      ref="farmForm"
      :model="farmForm"
      :rules="rules"
    >
      <FormItem label="养殖场名称" prop="farmerName">
        <Input
          clearable
          placeholder="请输入养殖场名称"
          style="width: 260px"
          v-model="farmForm.farmerName"
        ></Input>
      </FormItem>
      <FormItem label="养殖户名称" prop="name">
        <Input
          clearable
          placeholder="请输入养殖户名称"
          style="width: 260px"
          v-model="farmForm.name"
        ></Input>
      </FormItem>
      <FormItem label="电话号码" prop="tel">
        <Input
          clearable
          placeholder="请输入电话号码"
          style="width: 260px"
          v-model="farmForm.tel"
        ></Input>
      </FormItem>
      <FormItem label="养殖类型" prop="types">
        <Select
          clearable
          placeholder="请选择养殖类型"
          style="width: 260px"
          v-model="farmForm.types"
        >
          <Option
            v-for="(item, index) in catList"
            :key="index"
            :value="item.id + '/' + item.name"
            >{{ item.name }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="养殖地址" prop="farmerAddress">
        <Input
          clearable
          placeholder="请输入养殖地址"
          style="width: 260px"
          v-model="farmForm.farmerAddress"
        ></Input>
      </FormItem>
      <div style="width: 100%; text-align: center">
        <Button
          type="primary"
          style="width: 260px; margin-bottom: 20px"
          @click="submit"
        >
          确认注册并登录
        </Button>
      </div>
    </Form>
  </div>
</template>

<script>
import { V2 } from "@/common/http/api";
import axios from "axios";
import CU from "@/common/util/index";
export default {
  name: "",
  props: {
    form: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      farmForm: {
        //养殖场名称
        farmerName: "",
        //养殖户名字
        name: "",
        //养殖户电话
        tel: "",
        //养殖品种类型
        type: "",
        //养殖品种类型名称
        typeName: "",
        //养殖场地址
        farmerAddress: "",
        types: "",
      },
      rules: {
        name: [{ required: true, message: "请输入养植户名称" }],
        farmerName: [{ required: true, message: "请输入养殖场名称" }],
        types: [{ required: true, message: "请选择养植类型" }],
        farmerAddress: [{ required: true, message: "请输入养殖地址" }],
        tel: [
          { required: true, message: "请输入电话号码" },
          {
            validator(rule, value, callback) {
              if (CU.validatePhone(value)) {
                callback();
                return;
              }
              callback(rule.message);
            },
            message: "手机号格式不正确",
            trigger: "blur",
          },
        ],
      },
      catList: [],
    };
  },
  methods: {
    //养殖类型
    getCat() {
      axios({
        method: "post",
        url: V2 + this.$api.REGISTER.PRO,
        data: {
          type: 2,
        },
      }).then((res) => {
        this.catList = res.data.data.list;
      });
    },
    submit() {
      this.$refs.farmForm.validate().then((res) => {
        if (!res) return;
        axios({
          method: "post",
          url: V2 + this.$api.REGISTER.CHECKS_CODE,
          data: {
            phone: this.form.phone,
            code: this.form.code,
          },
        }).then((res) => {
          if (res.data.data) {
            let params = { ...this.farmForm, ...this.form };
            params.type = this.farmForm.types.split("/")[0];
            params.typeName = this.farmForm.types.split("/")[1];
            axios({
              method: "post",
              url: V2 + this.$api.REGISTER.REGIS,
              data: params,
            }).then(() => {
              this.$Message.success("注册成功！请返回登录界面登录！");
            });
          } else {
            this.$Message.error("验证码输入错误！");
          }
        });
      });
    },
  },
  mounted() {
    this.getCat();
  },
};
</script>

<style lang="less" scoped>
</style>